import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import { KendoDatePicker } from "../../Kendo/kendo_datepicker";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import axios from "axios";
import { toast } from "react-toastify";

export const BroucherConfig = () => {
  const [ContactUs, setContactUs] = useState({
    id: 0,
    faceBook: "",
    twitter: "",
    instagram: "",
    pinterest: "",
    linkedin: "",
    flickr: "",
    vimeo: "",
    contact: "",
    zoomLink: "",
    emailId: "",
    googleReview: "",
    savedBy: 0,
    broucherLink: "",
    corporateBroucherLink: "",
    broucherFile: [],
    broucherFileID: 0,
    broucherModel: [],
  });
  const [SbrochureList, setSBrochureList] = useState("");
  const [CbrochureList, setCBrochureList] = useState("");

  const [error, setError] = useState({});
  const [refreshflag, setrefreshflag] = useState(0);

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await corefetch("ContactUs/SocialMediaLinkDetails");
        if (response && response.length > 0) {
          setContactUs(response[0]);
          setSBrochureList(
            response[0].sBrochureFile
              ? `${ImageURL}${response[0].sBrochureFile}`
              : ""
          );
          setCBrochureList(
            response[0].cBrochureFile
              ? `${ImageURL}${response[0].cBrochureFile}`
              : ""
          );
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchData();
  }, [refreshflag]);

  const clearForm = () => {
    setContactUs({
      id: 0,
      faceBook: "",
      twitter: "",
      instagram: "",
      pinterest: "",
      linkedin: "",
      flickr: "",
      vimeo: "",
      contact: "",
      zoomLink: "",
      emailId: "",
      googleReview: "",
      // corporatebroucherLink: "",
      savedBy: 0,
      broucherFile: [],
      broucherFileID: 0,
      broucherModel: [],
    });
    setError({});
  };

  const validateFields = () => {
    const requiredFields = [
      "faceBook",
      "twitter",
      "instagram",
      "linkedin",
      "contact",
      "emailId",
      "pinterest",
      "vimeo",
      "broucherLink",
      "corporateBroucherLink",
    ];
    const newErrors = {};

    // Regular expression for allowing only numbers (for contact)
    const usPhonePattern = /^\(\d{3}\) \d{3}-\d{4}$/;
    const urlPattern =
      /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*(\?[^\s]*)?(\#[^\s]*)?$/i;

    // const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/i;
    const customFieldNames = {
      faceBook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      pinterest: "Pinterest",
      vimeo: "Vimeo",
      emailId: "Email ID",
      broucherLink: "Social Events Link",
      corporateBroucherLink: "Corporate Events Link",
    };

    requiredFields.forEach((field) => {
      const value = ContactUs[field] || "";
      const fieldName =
        customFieldNames[field] ||
        field
          .replace(/([A-Z])/g, " $1")
          .charAt(0)
          .toUpperCase() + field.slice(1);

      if (value.trim() == "") {
        newErrors[field] = `${fieldName} is required`;
      }

      // Check if "Facebook" is present in the Facebook field
      if (
        field == "faceBook" &&
        value.trim() !== "" &&
        !value.toLowerCase().includes("facebook")
      ) {
        newErrors.faceBook = "Please enter a valid Facebook URL.";
      }

      // Check if "Instagram" is present in the Instagram field
      if (
        field == "instagram" &&
        value.trim() !== "" &&
        !value.toLowerCase().includes("instagram")
      ) {
        newErrors.instagram = "Please enter a valid Instagram URL.";
      }

      // Check if "Twitter" is present in the Twitter field
      if (
        field == "twitter" &&
        value.trim() !== "" &&
        !value.toLowerCase().includes("twitter")
      ) {
        newErrors.twitter = "Please enter a valid twitter URL.";
      }
      if (
        field == "pinterest" &&
        value.trim() !== "" &&
        !/pinterest\.com/.test(value.toLowerCase())
      ) {
        newErrors.pinterest = "Please enter a valid Pinterest URL.";
      }

      // Check if "LinkedIn" is present in the LinkedIn field
      if (
        field == "linkedin" &&
        value.trim() !== "" &&
        !value.toLowerCase().includes("linkedin")
      ) {
        newErrors.linkedin = "Please enter a valid LinkedIn URL.";
      }

      if (
        field === "emailId" &&
        value.trim() !== "" &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      ) {
        newErrors.emailId = "Please enter a valid email address.";
      }

      if (
        field == "contact" &&
        value.trim() !== "" &&
        !usPhonePattern.test(value)
      ) {
        newErrors.contact = "Please enter a valid 10-digit phone number";
      }

      if (
        field == "broucherLink" &&
        value.trim() != "" &&
        !urlPattern.test(value)
      ) {
        newErrors.broucherLink = "Please enter a valid link.";
      }
      if (
        field == "corporateBroucherLink" &&
        value.trim() != "" &&
        !urlPattern.test(value)
      ) {
        newErrors.corporateBroucherLink = "Please enter a valid link.";
      }

      // if (!SbrochureList || SbrochureList.length == 0) {
      //   newErrors.broucherFile = "Broucher File is required";
      // }
    });

    setError(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (validateFields()) {
      try {
        const formData = new FormData();

        Object.keys(ContactUs).forEach((key) => {
          formData.append(key, ContactUs[key]);
        });
        // if (removedBrochureIds.length > 0) {
        //   var ids = removedBrochureIds.join(",");
        //   formData.append("RemovedImageIds", ids);
        // }

        // SbrochureList.forEach((brochure, index) => {
        //   if (brochure?.isNew && brochure.fileData) {
        //     formData.append(
        //       `BroucherModel[${index}].BroucherFile`,
        //       brochure.fileData
        //     );
        //   }
        // });

        await corepost(
          "ContactUs/InsertUpdateSocialMediaLinks",
          formData,
          true,
          true,
          false,
          false
        );

        // setSBrochureList((prevList) =>
        //   prevList.map((brochure) => ({
        //     ...brochure,
        //     isNew: false,
        //   }))
        // );

        setrefreshflag((prev) => prev + 1);
        clearForm();
      } catch (error) {
        console.error("Error posting data", error);
      }
    } else {
      console.log("Validation failed");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setError((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));

    setContactUs((prevState) => ({
      ...prevState,
      [name]: value || "",
    }));
  };

  const [removedBrochureIds, setRemovedBrochureIds] = useState([]);

  const handleRemoveFile = async () => {
    setSBrochureList("");
    await corefetch(
      `ContactUs/DeleteBroucher?IsCorporate=${false}&DeletedBy=${sessionUser()}`,
      true,
      false,
      true
    );
  };
  const ChandleRemoveFile = async () => {
    setCBrochureList("");

    await corefetch(
      `ContactUs/DeleteBroucher?IsCorporate=${true}&DeletedBy=${sessionUser()}`,
      true,
      false,
      true
    );
  };

  const [loading, setLoading] = useState(false);
  const [Cloading, setCLoading] = useState(false);

  const ShandleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    const validPDFs = files.filter((file) => file.type == "application/pdf");

    if (validPDFs.length !== files.length) {
      setError({ SValidFile: "Files must be valid PDF documents." });
      return;
    }

    const maxFileSize = 30 * 1024 * 1024;
    const oversizedFiles = validPDFs.filter((file) => file.size > maxFileSize);

    if (oversizedFiles.length > 0) {
      toast.error("File size must not exceed 30 MB.");
      $("#SbFile").val("");
      return;
    }

    setError((prev) => ({
      ...prev,
      SValidFile: "",
      SbroucherFile: false,
    }));

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("broucher", files[0]);
      formData.append("IsCorporate", false);
      formData.append("SavedBy", sessionUser());

      const response = await corepost("ContactUs/SaveBroucher", formData);

      // const brochureDetails = validPDFs.map((file) => ({
      //   filePath: URL.createObjectURL(file),
      //   fileName: file.name,
      //   fileData: file,
      //   IsCorporate: false,
      //   SavedBy: sessionUser(),
      //   RemovedImageIds: "",
      //   isNew: true,
      //   broucherFileID: response,
      // }));
      setSBrochureList(URL.createObjectURL(validPDFs[0]));
    } catch (err) {
      console.error("Error uploading file:", err);
      setError({ broucherFile: "Failed to upload file. Please try again." });
    } finally {
      setLoading(false);
    }

    $("#SbFile").val("");
  };
  const ChandleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    const validPDFs = files.filter((file) => file.type === "application/pdf");

    if (validPDFs.length !== files.length) {
      setError({ CValidFile: "Files must be valid PDF documents." });
      return;
    }

    const maxFileSize = 30 * 1024 * 1024;
    const oversizedFiles = validPDFs.filter((file) => file.size > maxFileSize);

    if (oversizedFiles.length > 0) {
      toast.error("File size must not exceed 30 MB.");
      $("#SbFile").val("");
      return;
    }

    setError((prev) => ({
      ...prev,
      CValidFile: "",
      CorporatebroucherFile: false,
    }));

    setCLoading(true);
    try {
      const formData = new FormData();
      formData.append("broucher", files[0]);
      formData.append("IsCorporate", true);
      formData.append("SavedBy", sessionUser());

      const response = await corepost("ContactUs/SaveBroucher", formData);

      const brochureDetails = validPDFs.map((file) => ({
        filePath: URL.createObjectURL(file),
        fileName: file.name,
        fileData: file,
        IsCorporate: true,
        SavedBy: sessionUser(),
        RemovedImageIds: "",
        isNew: true,
        broucherFileID: response,
      }));

      setCBrochureList(brochureDetails);
    } catch (err) {
      console.error("Error uploading file:", err);
      setError({ broucherFile: "Failed to upload file. Please try again." });
    } finally {
      setCLoading(false);
    }

    $("#CbFile").val("");
  };

  return (
    <div>
      <div className="row">
        {/* <div className="col-md-4 mb-3">
          <label className="form-label">
            Facebook <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="faceBook"
            value={ContactUs.faceBook}
            onChange={handleInputChange}
          />
          {error.faceBook && (
            <div className="text-danger">{error.faceBook}</div>
          )}
        </div> */}

        {/* <div className="col-md-4 mb-3">
          <label className="form-label">
            X <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="twitter"
            value={ContactUs.twitter}
            onChange={handleInputChange}
          />
          {error.twitter && <div className="text-danger">{error.twitter}</div>}
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">
            Instagram <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="instagram"
            value={ContactUs.instagram}
            onChange={handleInputChange}
          />
          {error.instagram && (
            <div className="text-danger">{error.instagram}</div>
          )}
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">
            Pinterest
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="pinterest"
            value={ContactUs.pinterest}
            onChange={handleInputChange}
          />
          {error.pinterest && (
            <div className="text-danger">{error.pinterest}</div>
          )}
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">
            LinkedIn <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="linkedin"
            value={ContactUs.linkedin}
            onChange={handleInputChange}
          />
          {error.linkedin && (
            <div className="text-danger">{error.linkedin}</div>
          )}
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Flickr</label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="flickr"
            value={ContactUs.flickr}
            onChange={handleInputChange}
          />
          {error.flickr && <div className="text-danger">{error.flickr}</div>}
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Vimeo</label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="vimeo"
            value={ContactUs.vimeo}
            onChange={handleInputChange}
          />
          {error.vimeo && <div className="text-danger">{error.vimeo}</div>}
        </div> */}

        <div className="col-md-4 mb-3">
          <label className="form-label">
            Contact <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            maxLength={14} // Maximum length for the formatted number
            className="form-control field"
            name="contact"
            value={ContactUs.contact || ""}
            placeholder="Enter phone number"
            onChange={(e) => {
              // Remove all non-numeric characters
              let rawValue = e.target.value.replace(/\D/g, "");

              // Restrict to 10 digits
              if (rawValue.length > 10) rawValue = rawValue.substring(0, 10);

              // Format the number as (123) 456-7890
              let formattedValue = "";
              if (rawValue.length > 6) {
                formattedValue = `(${rawValue.substring(
                  0,
                  3
                )}) ${rawValue.substring(3, 6)}-${rawValue.substring(6)}`;
              } else if (rawValue.length > 3) {
                formattedValue = `(${rawValue.substring(
                  0,
                  3
                )}) ${rawValue.substring(3)}`;
              } else if (rawValue.length > 0) {
                formattedValue = `(${rawValue}`;
              }

              // Update the state
              setContactUs((prev) => ({
                ...prev,
                contact: formattedValue,
              }));

              // Handle validation
              if (rawValue.length === 0) {
                setError((prevError) => ({
                  ...prevError,
                  contact: "Contact is required",
                }));
              } else if (rawValue.length < 10) {
                setError((prevError) => ({
                  ...prevError,
                  contact: "Please enter a valid 10-digit phone number",
                }));
              } else {
                setError((prevError) => ({
                  ...prevError,
                  contact: null,
                }));
              }
            }}
            onKeyDown={(e) => {
              const rawValue = ContactUs.contact?.replace(/\D/g, "");
              if (
                rawValue.length >= 10 &&
                !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(
                  e.key
                )
              ) {
                e.preventDefault(); // Prevent further input if 10 digits are already entered
              }
            }}
            onPaste={(e) => {
              e.preventDefault();
              const pastedText = e.clipboardData.getData("Text");
              let rawValue = pastedText.replace(/\D/g, ""); // Remove non-numeric characters

              // Restrict to 10 digits
              if (rawValue.length > 10) rawValue = rawValue.substring(0, 10);

              // Format the number as (123) 456-7890
              let formattedValue = "";
              if (rawValue.length > 6) {
                formattedValue = `(${rawValue.substring(
                  0,
                  3
                )}) ${rawValue.substring(3, 6)}-${rawValue.substring(6)}`;
              } else if (rawValue.length > 3) {
                formattedValue = `(${rawValue.substring(
                  0,
                  3
                )}) ${rawValue.substring(3)}`;
              } else if (rawValue.length > 0) {
                formattedValue = `(${rawValue}`;
              }

              // Update the state
              setContactUs((prev) => ({
                ...prev,
                contact: formattedValue,
              }));

              // Handle validation
              if (rawValue.length === 0) {
                setError((prevError) => ({
                  ...prevError,
                  contact: "Contact is required",
                }));
              } else if (rawValue.length < 10) {
                setError((prevError) => ({
                  ...prevError,
                  contact: "Please enter a valid 10-digit phone number",
                }));
              } else {
                setError((prevError) => ({
                  ...prevError,
                  contact: null,
                }));
              }
            }}
          />
          {error.contact && <div className="text-danger">{error.contact}</div>}
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Zoom Link</label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="zoomLink"
            value={ContactUs.zoomLink}
            onChange={handleInputChange}
          />
          {error.zoomLink && (
            <div className="text-danger">{error.zoomLink}</div>
          )}
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">
            Email ID <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="emailId"
            value={ContactUs.emailId}
            onChange={handleInputChange}
          />
          {error.emailId && <div className="text-danger">{error.emailId}</div>}
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Google Review</label>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="googleReview"
            value={ContactUs.googleReview}
            onChange={handleInputChange}
          />
          {error.googleReview && (
            <div className="text-danger">{error.googleReview}</div>
          )}
        </div>
        <div className="col-md-4 mb-3">
          <label className="form-label">Social Events Link</label>{" "}
          <span className="text-danger">*</span>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="broucherLink"
            placeholder="Social Events Link"
            value={ContactUs.broucherLink}
            onChange={handleInputChange}
          />
          {error.broucherLink && (
            <div className="text-danger">{error.broucherLink}</div>
          )}
        </div>
        <div className="col-md-4 mb-3">
          <label className="form-label">Corporate Events Link</label>{" "}
          <span className="text-danger">*</span>
          <input
            type="text"
            maxLength={200}
            className="form-control field"
            name="corporateBroucherLink"
            placeholder="Corporate Events Link"
            value={ContactUs.corporateBroucherLink}
            onChange={handleInputChange}
          />
          {error.corporateBroucherLink && (
            <div className="text-danger">{error.corporateBroucherLink}</div>
          )}
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Social Events File</label>{" "}
          <InfoIcon
            content="Please upload PDF files with a maximum size of
            30MB."
          />
          <input
            type="file"
            id="SbFile"
            className="form-control"
            name="SBroucherFile"
            accept=".pdf"
            onChange={ShandleFileChange}
            disabled={loading || SbrochureList}
          />
          {error.SbroucherFile && (
            <div className="text-danger">{error.SbroucherFile}</div>
          )}
          {error.SValidFile && (
            <div className="text-danger">{error.SValidFile}</div>
          )}
          <div className="col-md-12">
            {/* Spinner Loader */}
            {loading && (
              <div className="text-center my-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Uploading...</span>
                </div>
                <p>Uploading...</p>
              </div>
            )}
            <div className="listitems">
              {SbrochureList && (
                <div className="list-item pdf-list-item">
                  <a
                    href={`${SbrochureList}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    <img
                      src="assets/images/PDFImage/download.png"
                      alt="PDF Icon"
                      style={{
                        width: "50px",
                        height: "50px",
                        display: "block",
                        margin: "0 auto 5px",
                      }}
                    />
                  </a>
                  {/* File Name */}
                  <a
                    href={`${SbrochureList}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    {"Social Brochure"}
                  </a>

                  {/* Remove Button */}
                  <button
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                      background: "red",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                      display: "flex", // Enable Flexbox
                      alignItems: "center", // Vertically center
                      justifyContent: "center", // Horizontally center
                      fontSize: "14px", // Adjust the size of the X mark
                    }}
                    className="close"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveFile();
                    }}
                  >
                    ×
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <label className="form-label">Corporate Events File</label>{" "}
          <InfoIcon
            content="Please upload PDF files with a maximum size of
            30MB."
          />
          <input
            type="file"
            id="CbFile"
            className="form-control"
            name="CorporateBroucherFile"
            accept=".pdf"
            onChange={ChandleFileChange}
            disabled={Cloading || CbrochureList}
          />
          {error.CbroucherFile && (
            <div className="text-danger">{error.CbroucherFile}</div>
          )}
          {error.CValidFile && (
            <div className="text-danger">{error.CValidFile}</div>
          )}
          <div className="col-md-12">
            {/* Spinner Loader */}
            {Cloading && (
              <div className="text-center my-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Uploading...</span>
                </div>
                <p>Uploading...</p>
              </div>
            )}
            <div className="listitems">
              {CbrochureList && (
                <div className="list-item pdf-list-item">
                  <a
                    href={`${CbrochureList}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    <img
                      src="assets/images/PDFImage/download.png"
                      alt="PDF Icon"
                      style={{
                        width: "50px",
                        height: "50px",
                        display: "block",
                        margin: "0 auto 5px",
                      }}
                    />
                  </a>
                  {/* File Name */}
                  <a
                    href={`${CbrochureList}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    {"Corporate Brochure "}
                  </a>

                  {/* Remove Button */}
                  <button
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                      background: "red",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                      display: "flex", // Enable Flexbox
                      alignItems: "center", // Vertically center
                      justifyContent: "center", // Horizontally center
                      fontSize: "14px", // Adjust the size of the X mark
                    }}
                    className="close"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      ChandleRemoveFile();
                    }}
                  >
                    ×
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3 ms-auto text-end">
            <Button name={"Update"} onClick={onSubmit} />
          </div>
        </div>
      </div>
    </div>
  );
};
